import * as React from "react";
import { Link } from "react-router-dom";
export interface Props {}

export interface State {}

export default class Logo extends React.Component<Props, State> {
  render() {
    return (
      <Link to="/">
        <img
          src="https://minio.pisku.la/public/JG_colorOnWhite.svg"
          style={{ paddingBottom: "1em" }}
        />
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.tsx